import React, { useState } from 'react'
import LabExamsFilter from '../labExamsFIlter'
import LabExamsList from '../labExamsList'
import { TableContainer } from './styles'

const ImportedExamsTable = () => {
  const [filter, setFilter] = useState({
    selectedOption: 0,
    searchTerm: ''
  })

  const handleDateRangeChange = (option) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      selectedOption: option.value
    }))
  }

  const handleSearch = (searchTerm) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      searchTerm
    }))
  }

  return (
    <>
      <LabExamsFilter
        onDateRangeChange={handleDateRangeChange}
        onSearch={handleSearch}
      />
      <TableContainer>
        <LabExamsList filter={filter} />
      </TableContainer>
    </>
  )
}

export default ImportedExamsTable
